"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaCurrencyToJSON = exports.RosettaCurrencyFromJSONTyped = exports.RosettaCurrencyFromJSON = void 0;
const runtime_1 = require("../runtime");
function RosettaCurrencyFromJSON(json) {
    return RosettaCurrencyFromJSONTyped(json, false);
}
exports.RosettaCurrencyFromJSON = RosettaCurrencyFromJSON;
function RosettaCurrencyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'symbol': json['symbol'],
        'decimals': json['decimals'],
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : json['metadata'],
    };
}
exports.RosettaCurrencyFromJSONTyped = RosettaCurrencyFromJSONTyped;
function RosettaCurrencyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'symbol': value.symbol,
        'decimals': value.decimals,
        'metadata': value.metadata,
    };
}
exports.RosettaCurrencyToJSON = RosettaCurrencyToJSON;
//# sourceMappingURL=RosettaCurrency.js.map